<!--
     <ProcessDependingUserField
       :props="my_attrs_dictionary"
       @bind="my_bind_handler"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - id [REQUIRED] → This instance id.
     - process_field_id [REQUIRED] → The id of a process select to watch
     - permission_id [REQUIRED] → The permission_id, like "NCDEFAULT.evaluador"
     - multiple (default: false)
     - value
     - label
     - placeholder
-->

<template>
  <v-autocomplete
    v-model="props.value"
    :items="items"
    :label="props.label"
    :placeholder="props.placeholder"
    :multiple="props.multiple"
    :loading="loading"
    :readonly="!!props.readonly"
    :item-value="props.item_value || '0'"
    :item-text="props.item_text || '1'"
    :rules="rules"
    :class="[
      props.class || props.readonly ? 'qmkey-form-input-readonly': 'qmkey-form-input',
      { required: props.required }
      ]"
    outlined
    dense
    :clearable="!props.required && !props.readonly"
    :small-chips="props.chips"
    deletable-chips
    :disabled="!!props.disabled || !!props.readonly"
    @change="update"
  >
    <template>
      <v-icon slot="append" color="primary" v-if="!props.disabled && !props.readonly">
        {{ false || 'mdi-menu-down' }}
      </v-icon>
      <div v-else slot="append"></div> <!-- Hide icon -->
    </template>
  </v-autocomplete>
</template>


<script>
import { mapGetters } from 'vuex'
import QUnitWidgets from '@/api/QUnitWidgets'

export default {
  name: 'ProcessDependingUserField',

  props: ['props','form_values'],

  data: () => ({
    items: [],
    loading: false,
  }),

  computed: {
    ...mapGetters(['sitePath', 'centro_id']),

    value() {
      //return this.props.value
      let r = this.props.value || null;
      if (
        this.props.value &&
        this.props.multiple &&
        this.props.value.length < 1
      ) {
        r = null;
      }
      return r
    },
    
    rules() {
      // TODO: Multilang: Change hardcoded string
      return [(value) => !!value || !this.props.required || this.$vuetify.lang.translator('required_field')]
    },

    process_id() {
      return this.form_values.affected_process
    },
  },

  mounted() {
    this.items = this.props.items || []
  },

  methods: {
    validate() {
      // TODO: Show error message
      return !this.props.required || !!this.value
    },

    update_items(process_id) {
      if (!process_id) {
        this.update();
        this.items = [];
        return;
      }

      this.loading = true
      // Updates the information because another process is selected
      const centro_id = this.props.current_unit ? this.props.current_unit._protected.centro : this.centro_id;
      console.log('ProcessDependingUserField.update_items(', process_id, centro_id, ')');
      QUnitWidgets.get_process_depending_users(this.sitePath, {
        process_id: process_id,
        permission_id: this.props.permission_id,
        centro: centro_id,
      })
        .then(
          function (data) {
            this.loading = false;
            console.log(
              'DEBUGGING ProcessDependingUserField.update_items() → ',
              data,
            )
            this.items = data.data
          }.bind(this),
        )
        .catch((err) => console.warn(err)) // DEBUG
    },

    error_state(ok) {
      this.valid = ok
    },

    update(value) {
      this.$emit('update',value);
    },
  },
  watch: {
    process_id() {
      this.update_items(this.process_id);
    },
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>
